export enum TenantModuleEnum {
  AI = 'ai'
}

export const tenantModuleLabels = {
  [TenantModuleEnum.AI]: 'Inteligência artificial'
}
